import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useStore } from "../stores/store";
import { useTranslation } from "react-i18next";

const Unauthorized = () => {
  const { mainStore } = useStore();
  const { t } = useTranslation();

  useEffect(() => {
    mainStore.setMenuNo(-1);
    // eslint-disable-next-line
  }, [mainStore]);

  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: '60vh' }}
    >
      <div className="text-center p-4">
        <h1 style={{ fontSize: '4rem', color: '#dc3545' }}>403</h1>
        <h4 style={{ color: '#333', marginBottom: '1rem' }}>
          {t("unauthorizedTitle") || "Access Denied"}
        </h4>
        <p className="text-muted mb-4">
          {t("unauthorizedMessage") || "You do not have permission to access this page."}
        </p>
        <Link
          to="/"
          className="btn btn-lg"
          style={{ backgroundColor: '#112d4e', color: '#fff', border: 'none' }}
        >
          {t("backToLogin") || "Back to Login"}
        </Link>
      </div>
    </div>
  );
};

export default Unauthorized;
